import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Proposal } from 'src/app/services/api/proposal';
import { ProposalStatus } from 'src/app/services/api/proposal-status';
import { ProposalStatusService } from 'src/app/services/api/proposal-status.service';
import { HelpersService } from 'src/app/services/shared/helper.service';
import { ProposalStatusComponent } from '../proposal-status/proposal-status.component';

@Component({
  selector: 'app-set-prioritas',
  templateUrl: './set-prioritas.component.html',
  styleUrls: ['./set-prioritas.component.scss']
})
export class SetPrioritasComponent {

  priority: Proposal[];
  selectedPriority: Proposal[];
  form: FormGroup

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public helper: HelpersService,
    public service: ProposalStatusService,
    public fb: FormBuilder,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ProposalStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.form = this.fb.group({
      priority: [data.currentPriority, Validators.required]
    })
    this.selectedPriority = data.priority
  }

  onConfirm(): void {
    this.dialogRef.close(this.form.value);
  }
 
  onDismiss(): void {
    this.dialogRef.close(false);
  }

}
